<template>
    <div class="user_auth">
        <div class="user_auth_container">
            <div class="title">个人认证</div>
            <div class="user_step">
                <el-steps align-center :active="active" finish-status="success">
                    <el-step :class="{ 'stepone': active == 1 }" title="提交资料认证" />
                    <el-step title="等待资料审核" />
                    <el-step title="实名认证成功" />
                </el-steps>
            </div>
            <div class="form_container">
                <el-form :disabled="disabled" ref="form" :model="userForm" :rules="rules" label-width="116px">
                    <el-form-item label="您的姓名" prop="fullName">
                        <el-input placeholder="请填写身份证上的真实姓名" v-model.trim="userForm.fullName"></el-input>
                    </el-form-item>
                    <el-form-item label="身份证号" prop="identityCardNo">
                        <el-input placeholder="请填写18位身份证号码" v-model.trim="userForm.identityCardNo"></el-input>
                    </el-form-item>
                    <el-form-item label="身份证照片" prop="avatarUrl" :error="nameError">
                        <div class="img_container" style="display: flex;"><upload-img :default-url="userForm.avatarUrl" tiptext="身份证人像面"
                                @onSuccess="uploadSuccess($event, 'avatarUrl')"></upload-img>
                            <upload-img tiptext="身份证国徽面" class="img_mid" :default-url="userForm.nationalEmblemUrl"
                                @onSuccess="uploadSuccess($event, 'nationalEmblemUrl')"></upload-img>
                            <upload-img tiptext="手持身份证正面(确保身份证清晰)" :default-url="userForm.holdIdentityCardUrl"
                                @onSuccess="uploadSuccess($event, 'holdIdentityCardUrl')"></upload-img>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <div class="notice_tip">
                <div style="font-weight: 500;">注意事项</div>
                <div style="margin-left: 24px;">
                    <p>1.同一个身份证号只能认证一个账号；</p>
                    <p>2.身份证国徽面与正面信息应为同一身份证的信息且在有效期内；</p>
                    <p>3.所有上传照片需清晰且未遮挡，请勿进行美化和修改，以免认证失败；</p>
                    <p>4.传本人手持身份证信息面照片中应含有本人头部或上半身；</p>
                    <p>5.手持身份证照中本人形象需为免冠且并未化妆，五官清晰；</p>
                    <p>6.拍照手持身份证照时对焦点请置于身份证上，保证身份证信息清晰且未遮挡；</p>
                    <p>7.上传图片文件格式支持png，jpg和bmp；</p>
                    <p>8.单张图片大小不超过3MB，尺寸最小为500px * 500px；</p>
                    <p>9.所有上传信息均会被妥善保管，不会用于其他商业用途或传输给其他第三方；</p>
                </div>
            </div>
            <div class="submit-btn">
                <el-button :disabled="disabled" style="transform: translateX(-12px);" @click="submitForm" color="#386AEA">提交认证资料</el-button>
            </div>
        </div>
    </div>
</template>

<script setup>
import UploadImg from '@/components/UploadImg/index.vue'
import { validateUserCode, validateUserName } from '@/utils/common.js'
import { authenticationApi ,authenticationdetailApi} from '@/api/control'
import { ElMessage } from 'element-plus'
import { ref } from 'vue'
import { useRouter } from 'vue-router'
const router = useRouter()
const disabled = ref(false)
const active = ref(1)//步骤条
//表单dom
const form = ref(null)
const nameError = ref('')

const userForm = ref({
    fullName: '',
    identityCardNo: '',
    avatarUrl: '',
    nationalEmblemUrl: '',
    holdIdentityCardUrl: '',
})
//上传成功
const uploadSuccess = (imgUrl, type) => {
    console.log('上传获取: ', imgUrl, type)
    userForm.value[type] = imgUrl
}
//表单校验规则
const rules = ref({
    fullName: [
        { required: true, message: '请填写姓名', trigger: 'blur' },
        { validator: validateUserName, trigger: 'blur' }
    ],
    identityCardNo: [
        { required: true, message: '请填写身份证号', trigger: 'blur' },
        { validator: validateUserCode, trigger: 'blur' }
    ],
    avatarUrl: [{ required: true, message: '请上传身份证照片', trigger: 'blur' }],
})
//提交表单
const submitForm = () => {
    // 发送认证请求
    form.value.validate((value) => {
        console.log(value);
        if (value && userForm.value.nationalEmblemUrl && userForm.value.holdIdentityCardUrl) {
            authenticationApi({
                        ...userForm.value,
                        authenticationType: '1',
                    }).then(res => {
                        console.log(res);
                        if (res.code === 200) {
                            active.value = 2
                            // disabled.value = true
                            router.push('/home/controlsyshome')
                            ElMessage({
                                message: res.message,
                                customClass: "custom-message1",
                            });
                        }
                    }).catch(err => { console.log(err); })
        } else {
            if(!(userForm.value.nationalEmblemUrl && userForm.value.holdIdentityCardUrl)){nameError.value = '请上传身份证照片'}
        }
    })
}
</script>

<style lang="scss" scoped>
@media (max-width: 1200px) {
    .user_auth_container {
        width: calc(100vw - 80px);
        .img_container{
            flex-wrap: wrap;
            .img_mid{
                margin: 16px 0px;
            }
        }
    }
}

@media (min-width: 1200px) {
    .user_auth_container {
        width: 1105px;
        .form_container{
            padding-left: 137px;
            .img_mid{
                margin: 0px 16px;
            }
        }
    }
}

.user_auth {
    background-color: #f8f8f8;
    padding: 24px 0px 40px;
    min-height: 100vh;

    .user_auth_container {
        min-height: 1040px;
        padding-bottom: 80px;
        margin: 0 auto;
        background-color: #fff;
        border-radius: 4px;
        padding-top: 32px;
        padding-left: 24px;

        .el-button {
            width: 176px;
            height: 64px;
            font-weight: 500;
            font-size: 16px;
        }

        .notice_tip {
            display: flex;
            margin-left: 165px;
            color: #333;
            margin-top: 40px;

            div p {
                margin-bottom: 0px;
                line-height: 1.8;
                color: #999;
                // font-family: PingFang SC;
                font-size: 12px;
                font-weight: 500
            }
        }

        ::v-deep .el-input__inner {
            // background-color: #292929 !important;
            // -webkit-box-shadow: 0 0 0 1000px #292929 inset;
            // -webkit-text-fill-color: #fff !important;
            // color: #fff !important;
            caret-color: #386AEA;
            font-size: 16px;
            color: #333;
            // caret-color: #386AEA;
        }

        // ::v-deep .el-checkbox__inner {
        //     border: 0.5px solid #ffffff32;
        // }
        ::v-deep .el-form-item {
            width: 480px;
            margin-bottom: 16px;
            align-items: center;
        }

        ::v-deep .el-form-item.is-error {
            margin-bottom: 48px;
        }

        ::v-deep .el-form-item.is-error .el-input__wrapper {
            box-shadow: 0 0 0 0.5px #E70A27 inset !important;
        }

        ::v-deep .el-input__wrapper {
            width: 400px;
            height: 64px;
            padding: 1px 24px;
            background: rgba(0, 0, 0, 0.05);
            box-shadow: 0 0 0 0.5px rgba(0, 0, 0, 0.2) inset !important;
        }

        ::v-deep .el-form-item__label {
            padding-right: 24px;
            color: #333;
            font-size: 16px;
            font-weight: 500;
        }

        ::v-deep .el-form-item__error {
            color: #E70A27;
            line-height: 24px;
            padding-top: 0px;
            margin: 8px 0px 16px;
            font-weight: 500;
        }

        .stepone {
            ::v-deep .el-step__line-inner {
                width: 50% !important;
                border-width: 1px !important;
            }
        }

        ::v-deep .el-step__title.is-wait {
            color: #333;
            font-weight: 500;
        }

        ::v-deep .el-step__line {
            background-color: rgba(0, 0, 0, 0.1);
            height: 1px;
            // top: 7px;
        }

        ::v-deep .el-step__head.is-success {
            color: #386AEA;
            border-color: #386AEA;
        }

        ::v-deep .el-step__title.is-success,
        ::v-deep .el-step__title.is-process {
            color: #333;
            font-weight: 500;
        }

        ::v-deep .el-step__icon {
            width: 12px;
            height: 12px;
            background-color: #386AEA;
            border: none;

            svg,
            .el-step__icon-inner {
                display: none;
            }
        }

        .user_step {
            // width: 772px;
            margin: 90px 55px 99px 40px;
        }

        .title {
            color: #333;
            // font-family: PingFang SC;
            font-size: 24px;
            font-weight: 500;
        }
    }
    .submit-btn {
        text-align: center;
        margin-top: 40px;
    }
}
</style>
<style lang="scss">
.user_auth {
    .submit-btn {
        text-align: center;
        margin-top: 40px;
        .el-button {
            &:focus {
                background: #386AEA;
            }
            &:hover, &:active {
                background: rgb(116, 151, 240);
                border-color: rgb(116, 151, 240);
            }
        }
    }
}
</style>